import { useState } from 'react'

import type { Sort } from './types'

// Generic column sorter shared by the account-style summary tables. Rows are
// treated as open records so any table can sort on its own keys; missing
// values always sort last so empty cells don't lead.
export function useSort(initialSort: Sort) {
  const [sort, setSort] = useState<Sort>(initialSort)

  const toggleSort = (key: string) => {
    setSort((current) => ({
      key,
      direction:
        current.key === key && current.direction === 'asc' ? 'desc' : 'asc',
    }))
  }

  const sorter = (
    first: Record<string, unknown>,
    second: Record<string, unknown>,
  ) => {
    const firstValue = first[sort.key]
    const secondValue = second[sort.key]
    const direction = sort.direction === 'asc' ? 1 : -1

    const firstMissing =
      firstValue === null || firstValue === undefined || firstValue === ''
    const secondMissing =
      secondValue === null || secondValue === undefined || secondValue === ''
    if (firstMissing && secondMissing) return 0
    if (firstMissing) return 1
    if (secondMissing) return -1

    if (typeof firstValue === 'string' || typeof secondValue === 'string') {
      return direction * String(firstValue).localeCompare(String(secondValue))
    }
    return direction * (Number(firstValue) - Number(secondValue))
  }

  return { sort, setSort: toggleSort, sorter }
}
